import axios from 'axios';
import { attachAuthInterceptors } from '../../../../api/attachAuthInterceptors';
import { setToken } from './token';

const jwtAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
});

// IMPORTANTE: NO setear Authorization fijo aquí.
// Usar interceptores para leer el token fresco en cada request.
attachAuthInterceptors(jwtAxios, jwtAxios); // la base se refresca a sí misma

export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    localStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
  }
  setToken(token);
};

export default jwtAxios;

// import axios from 'axios';
// import { apiDocumentosBaseUrl } from '@crema/constants/AppConst';

// export const jwtAxios = axios?.create({
//   baseURL: apiDocumentosBaseUrl,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });
// jwtAxios.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     if (err.response && err.response.data.msg === 'Token is not valid') {
//       console.log('Need to logout user');
//       // store.dispatch({type: LOGOUT});
//     }
//     return Promise.reject(err);
//   },
// );
// export const setAuthToken = (token) => {
//   if (token) {
//     jwtAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
//     localStorage.setItem('token', token);
//   } else {
//     delete jwtAxios.defaults.headers.common['Authorization'];
//     localStorage.removeItem('token');
//   }
// };

// export default jwtAxios;
